import React from "react"
import {
  Box,
  Menu,
  MenuButton,
  MenuList,
  Portal,
} from "@chakra-ui/react"
import { Form } from "sharedTypes"
import Button from "components/Buttons/Button"
import SimpleBar from "simplebar-react"
import FormTypeFilter from "./FormTypeFilter"
import StatusFilter from "./StatusFilter"

type Props = {
  selectedFormIdFilters: string[]
  onSelectFormIdFilters: (filters) => void
  selectedStatusFilters: string[]
  onSelectStatusFilters: (filters) => void
  forms: Form[]
}

const FilterPopover = ({
  selectedFormIdFilters, onSelectFormIdFilters, selectedStatusFilters, onSelectStatusFilters, forms,
}: Props) => (
  <Menu closeOnSelect={false}>
    <MenuButton>
      <Button
        variant="outline"
        size="sm"
        rightIcon="down-arrow"
      >Filter
      </Button>
    </MenuButton>
    <Portal>
      <MenuList padding={0}>
        <Box as={SimpleBar} w={72} maxH="xl">
          <FormTypeFilter
            forms={forms}
            onSelectFormIdFilters={onSelectFormIdFilters}
            selectedFormIdFilters={selectedFormIdFilters}
          />
          <StatusFilter
            selectedStatusFilters={selectedStatusFilters}
            onSelectStatusFilters={onSelectStatusFilters}
          />
        </Box>
      </MenuList>
    </Portal>
  </Menu>
)

export default FilterPopover
